import Dbm from "dbm";
import Website from "../../index.js";

//import * as PIXI from "pixi.js";
//import Matter from "matter-js";

export default class HighscoreList extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        let layer = new PIXI.Container();
        this.item.requireProperty("pixiLayer", layer);
        this.item.requireProperty("isShowing", false);

        this.scores = [];
    }

    setup() {
        //console.log("setup");

        let margin = 5;
                
        let textBox = Dbm.flow.externalObject(new PIXI.Container());
        textBox.addProperty("y", Website.game.Sizes.HEIGHT, "position.y")
        this.item.pixiLayer.addChild(textBox.object);
        this.item.setValue("textBox", textBox.item);

        textBox.object.position.x = margin;
        textBox.object.position.y = margin;

        const textBoxBackground = Website.game.getButton("screens/frame", "main", 0, 7);
        textBoxBackground.width = Website.game.Sizes.WIDTH-2*margin;
        textBoxBackground.height = Website.game.Sizes.HEIGHT-2*margin;
        this.item.setValue("textBoxBackground", textBoxBackground);

        textBox.object.addChild(textBoxBackground);

        let personalAreaY = 10+10*10;

        const box = new PIXI.Graphics();
        box.beginFill(0x000000);
        box.drawRect(0, 0, Website.game.Sizes.WIDTH-2*margin-2*10, 1);
        box.endFill();
        box.position.set(10, personalAreaY);
        textBox.object.addChild(box);

        {
            let group = new PIXI.Container();
            group.position.set(10, personalAreaY+9);
            textBox.object.addChild(group);

            let rank = Dbm.getRepositoryItem("game").controller.getText("", 12, 0x000000);
            this.item.setValue("currentRank", rank);
            rank.position.set(60, 0);
            group.addChild(rank);

            let name = Dbm.getRepositoryItem("game").controller.getText("Nuvarande", 12, 0x000000);
            
            group.addChild(name);

            let score = Dbm.getRepositoryItem("game").controller.getText("0", 12, 0x000000);
            this.item.setValue("currentScore", score);
            score.position.set(Website.game.Sizes.WIDTH-2*margin-2*10-score.width, 0);
            group.addChild(score);
        }

        {
            let group = new PIXI.Container();
            textBox.object.addChild(group);
            group.position.set(10, personalAreaY+9+10);

            let rank = Dbm.getRepositoryItem("game").controller.getText("", 12, 0x000000);
            this.item.setValue("highscoreRank", rank);
            rank.position.set(60, 0);
            group.addChild(rank);

            let name = Dbm.getRepositoryItem("game").controller.getText("Highscore", 12, 0x000000);
            group.addChild(name);

            let score = Dbm.getRepositoryItem("game").controller.getText("0", 12, 0x000000);
            this.item.setValue("highscoreScore", score);
            score.position.set(Website.game.Sizes.WIDTH-2*margin-2*10-score.width, 0);
            group.addChild(score);
        }

        let buttonHeight = 20;
        let buttonWidth = 120;

        {
            let startButton = new PIXI.Container();
            startButton.eventMode = "static";
            startButton.on("pointerdown", this.hide.bind(this));
            textBox.object.addChild(startButton);
            this.item.setValue("highscoreButton", startButton);

            const box = Website.game.getButton("screens/button-orange");
            box.width = buttonWidth;
            box.height = buttonHeight;
            this.item.highscoreButton.addChild(box);

            this.item.highscoreButton.x = 0.5*(Website.game.Sizes.WIDTH-2*margin-buttonWidth);
            this.item.highscoreButton.y = Website.game.Sizes.HEIGHT-2*margin-buttonHeight-10;
            
            let text = Dbm.getRepositoryItem("game").controller.getText("STÄNG");
            
            text.position.x = 0.5*(buttonWidth-text.width);
            text.position.y = 0.5*(buttonHeight-text.height);

            startButton.addChild(text);
        }
    }

    updateScores() {
        Dbm.graphapi.webclient.loadData("highscores", {"gameMode": Dbm.repository.getItem("site").gameMode}, this._scoresLoaded.bind(this));
    }

    _scoresLoaded(aData) {
        //console.log("_scoresLoaded");
        //console.log(aData);

        this._removeScores();

        let margin = 5;
        let rankNumber = 0;
        let lastScore = 0;

        let currentArray = aData["scores"];
        let currentArrayLength = currentArray.length;
        for(let i = 0; i < currentArrayLength; i++) {
            let currentScore = currentArray[i];
            let scoreItem = Dbm.getRepositoryItem(currentScore.id);

            if(currentScore.score != lastScore) {
                rankNumber++;
                lastScore = currentScore.score;
            }

            let scoreLayer = new PIXI.Container();
            scoreLayer.position.set(10, 10+i*10);
            this.item.textBox.object.addChild(scoreLayer);

            let rank = Dbm.getRepositoryItem("game").controller.getText("#" + rankNumber, 12, 0x000000);
            scoreLayer.addChild(rank);

            let name = Dbm.getRepositoryItem("game").controller.getText(scoreItem.name, 12, 0x000000);
            name.position.set(20, 0);
            scoreLayer.addChild(name);

            let score = Dbm.getRepositoryItem("game").controller.getText(scoreItem.score, 12, 0x000000);
            score.position.set(Website.game.Sizes.WIDTH-2*margin-2*10-score.width, 0);
            scoreLayer.addChild(score);

            this.scores.push(scoreLayer);
        }
    }

    

    _removeScores() {
        
        let currentArray = this.scores;
        let currentArrayLength = currentArray.length;
        for(let i = 0; i < currentArrayLength; i++) {
            currentArray[i].parent.removeChild(currentArray[i]);
        }

        this.scores = [];
    }

    updateCurrentPosition() {
        Dbm.graphapi.webclient.loadData("rank", {"score": this.item.game.score, "gameMode": Dbm.repository.getItem("site").gameMode}, this._currentPositionLoaded.bind(this));
    }

    _currentPositionLoaded(aData) {
        //console.log("_currentPositionLoaded");
        //console.log(aData);

        this.item.currentRank.text = "#" + aData["rank"];
    }

    updateHighscorePosition() {
        Dbm.graphapi.webclient.loadData("rank", {"score": this.item.game.highScore, "gameMode": Dbm.repository.getItem("site").gameMode}, this._highscorePositionLoaded.bind(this));
    }

    _highscorePositionLoaded(aData) {
        //console.log("_highscorePositionLoaded");
        //console.log(aData);

        this.item.highscoreRank.text = "#" + aData["rank"];
    }

    show() {
        this.item.isShowing = true;
        let margin = 5;
        this.item.textBox.properties.y.animateValue(margin, 0.3);

        this.item.highscoreScore.text = this.item.game.highScore;
        this.item.currentScore.text = this.item.game.score;

        this.item.currentScore.position.set(Website.game.Sizes.WIDTH-2*margin-2*10-this.item.currentScore.width, 0);
        this.item.highscoreScore.position.set(Website.game.Sizes.WIDTH-2*margin-2*10-this.item.highscoreScore.width, 0);
    }

    hide() {
        this.item.isShowing = false;
        this.item.textBox.properties.y.animateValue(Website.game.Sizes.HEIGHT, 0.3);
        let sound = Website.game.getTextures("sounds/interface", "click-beep")[0];
        sound.play({loop: false, volume: 0.5});
    }
}